// Locale
// import { en } from '../../locale'
import colors from "vuetify/lib/util/colors";
import whitelabelTheme from "./whitelabelTheme.json";

export const themeConfig = {
  disableCustomizer: false, // options[Boolean] : true, false(default)

  rtl: false, // options[Boolean] : true, false(default)
  verticalSidebarMini: false, // options[Boolean] : true, false(default)
  verticalSidebarDrawer: false, // options[Boolean] : true, false(default)
  verticalCompactSidebarDrawer: true, // options[Boolean] : true, false(default)
  verticalSaasSidebarDrawer: true, // options[Boolean] : true, false(default)
  showBreadcrumb: true, // options[Boolean] : true, false(default)

  layout: "VerticalSix", //VerticalCompactSidebar,VerticalSaasLayout,VerticalSidebar,HorizontalBar,VerticalSix
  isLoading: false,
  isDark: false,
  verticalSidebarDrawerColor: "white", // primary,white,sucsess,warning,etc
  appBarColor: "white", // primary,white,sucsess,warning,etc
};

const mq = window.matchMedia("(prefers-color-scheme: light)");

// export const vuetify = new Vuetify({
//   theme: { dark: mq.matches }
// });

// console.log(mq);

// mq.addEventListener("change", e => {
//   console.log(mq);
//   this.$vuetify.theme.dark = e.matches;
// });

export const texts = {
  footerDescription: whitelabelTheme?.texts?.footerDescription || "",
  loginTitle: whitelabelTheme?.texts?.loginTitle || "Faça login para continuar",
};
export const socialNetworks = whitelabelTheme?.socialNetworks || [];
export const appBarColor = whitelabelTheme?.colors?.appBar || "#272727"
export const footerBar = whitelabelTheme?.colors?.footerBar || "#272727"
export const hidePoweredBy = !!whitelabelTheme?.hidePoweredBy;
export const email = whitelabelTheme.email || "";
export const whatsapp = whitelabelTheme.whatsapp || "";
export const name = whitelabelTheme.name || "Plataforma";
export const legalInfo = {
  legalName: "Gabriel T Pastori Desenvolvimento de Software LTDA",
  fantasyName: "Tiqone",
  document: "59.995.826/0001-80"
}

export const themePreset = {
  breakpoint: {
    scrollBarWidth: 16,
    thresholds: {
      xs: 600,
      sm: 960,
      md: 1280,
      lg: 1920,
    },
  },

  rtl: false,

  theme: {
    // dark: mq.matches,
    dark: false,

    default: "light",
    disable: false,
    options: {
      cspNonce: undefined,
      customProperties: true,
      minifyTheme: undefined,
      themeCache: undefined,
    },
    themes: {
      light: {
        primary: "#7caf00",
        secondary: "#434343",
        success: colors.green,
        danger: colors.red,
        warning: colors.deepOrange,
        info: colors.indigo,
        dark: "#27144a",
        background: "#f2f3f8",

        ...(whitelabelTheme?.colors?.light || {}),
      },
      dark: {
        primary: "#7caf00",
        secondary: "#434343",
        success: colors.green,
        danger: colors.red,
        warning: colors.deepOrange,
        info: colors.indigo,

        ...(whitelabelTheme?.colors?.dark || {}),
      },
    },
  },
};
